export default __webpack_public_path__ + "static/media/collapse-arrow.db91568c.svg";